export function HWCLogo() {
  return (
    <img
      src="/logo.png"
      alt="Hobart Workers Club"
      className="h-auto w-64 drop-shadow-lg sm:w-80"
    />
  );
}
